"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _baseInfo = _interopRequireDefault(require("./components/baseInfo"));
var _ranking = _interopRequireDefault(require("./components/ranking"));
var _gridMenu = _interopRequireDefault(require("./components/gridMenu"));
var _permission = require("@/utils/permission");
var _systemSetting = require("@/api/systemSetting");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
//
//
//
//
//
//
//
//
//
//
//
// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2024 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------
// 权限判断函数
var _default = exports.default = {
  name: 'Dashboard',
  components: {
    baseInfo: _baseInfo.default,
    gridMenu: _gridMenu.default,
    ranking: _ranking.default
  },
  mounted: function mounted() {
    this.getMediadomain();
  },
  methods: {
    checkPermi: _permission.checkPermi,
    //图片域名
    getMediadomain: function getMediadomain() {
      var _this = this;
      (0, _systemSetting.mediadomainApi)().then(function (res) {
        localStorage.setItem('mediaDomain', res);
        _this.$store.commit('settings/SET_mediaDomain', res);
      });
    }
  }
};